export enum SEGMENT_PERMISSIONS {
  VIEW = 'SEGMENT_VIEW',
  WRITE = 'SEGMENT_WRITE',
  APPLY = 'SEGMENT_APPLY',
  ASSIGN = 'SEGMENT_ASSIGN',
  DELETE = 'SEGMENT_DELETE',
}
